// extracted by mini-css-extract-plugin
export default {"goto_top_btn":"style__goto_top_btn__u_i4k"};